/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState } from 'react'
// nodejs library that concatenates classes
import classnames from 'classnames'
import './index.css'
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from 'reactstrap'

import { useHistory } from 'react-router'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import avatarURL from '../../../../assets/img/brand/img_avatar.png'
// core components
import AuthHeader from 'components/Headers/AuthHeader.js'
import axios from 'axios'
import { ColumnToggle } from 'react-bootstrap-table2-toolkit'
import AxiosInstance from 'utils/AxiosInstance'
import { useSelector } from 'react-redux'
function FirstLogin() {
  const history = useHistory()
  const [focusedEmail, setfocusedEmail] = useState(false)
  const [focusedPassword, setfocusedPassword] = useState(false)

  const [userAvatar, setUserAvatar] = useState(avatarURL)
  const [userAvatarFile, setUserAvatarFile] = useState(null)

  const [name, setName] = useState('')
  const [surname, setSurname] = useState('')
  const [username, setUsername] = useState('')
  const [location, setLocation] = useState('')
  const [email, setEmail] = useState('')
  // elham#2019da
  // Elham!@#2024da
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [profileHover, setProfileHover] = useState(false)

  const onSubmit = (e) => {
    e.preventDefault()
    const hash = localStorage.getItem('token')

    const data = new FormData()

    data.append('first_name', name)
    data.append('last_name', surname)
    data.append('email', email)
    // data.append('hash', hash)
    data.append('language', 1)
    data.append('id', 'cf6f9ada-4639-4652-8e7e-04bb423e1e1a')

    if (password && password === confirmPassword) {
      data.append('password', password)
    } else {
      toast.error('Different passwords!', {
        position: toast.POSITION.BOTTOM_LEFT,
      })
    }

    if (userAvatarFile) {
      data.append('file', userAvatarFile)
    }

    AxiosInstance.post(`/users/change-password-required`, data)
      .then((res) => {
        console.log('in reees')
        if (res.success) {
          toast.success('Updated Success!', {
            position: toast.POSITION.BOTTOM_LEFT,
          })
          history.push('admin/profile')
        } else {
          toast.error('Password Wrong!', {
            position: toast.POSITION.BOTTOM_LEFT,
          })
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }

  const onImageChange = (e) => {
    const [file] = e.target.files
    setUserAvatar(URL.createObjectURL(file))

    setUserAvatarFile(file)
  }

  return (
    <>
      {/* <AuthHeader title='Welcome!' lead='To Kiwi learning menagemant system!' /> */}
      <div className='pb-7'></div>
      <Container className='h-100' style={{}}>
        <Row className='justify-content-center '>
          <Col xl='6' lg='7' md='8' xs='12'>
            <Card className='bg-secondary border-0 mb-0 overflow_unset'>
              <CardBody className='px-lg-5 py-lg-5'>
                <div className='text-center d-flex flex-column align-items-center text-muted mb-4'>
                  <div
                    className='circle absolute'
                    onMouseEnter={() => setProfileHover(true)}
                    onMouseLeave={() => setProfileHover(false)}
                  >
                    <div className='overlay-hover'>
                      <div className='d-flex justify-content-center'>
                        <Input
                          type='file'
                          className='img-input-style'
                          onChange={onImageChange}
                        />
                        <img
                          src={userAvatar}
                          alt='profile'
                          className='styledImage'
                        />
                      </div>
                    </div>
                    <div
                      className={`overlay-hover2 ${
                        profileHover ? '' : 'd-none'
                      }`}
                    >
                      <div className='d-flex justify-content-center'>
                        <Input
                          type='file'
                          className='img-input-style'
                          onChange={onImageChange}
                        />
                        <div className='overlay-text '>
                          <i className='ni ni-camera-compact' />
                          <p className='text-sm' style={{ lineHeight: '16px' }}>
                            Add Profile Image
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <small className='mt-5'>Change the credentials</small>
                </div>
                <Form role='form'>
                  <div className='d-flex justify-content-between'>
                    <FormGroup
                      className={classnames('mb-3 mr-2', {
                        focused: focusedEmail,
                      })}
                    >
                      <InputGroup className='input-group-merge input-group-alternative'>
                        <InputGroupAddon addonType='prepend'>
                          <InputGroupText>
                            <i className='ni ni-single-02' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder='Name'
                          value={name}
                          type='text'
                          onFocus={() => setfocusedEmail(true)}
                          onBlur={() => setfocusedEmail(false)}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames({
                        focused: focusedPassword,
                      })}
                    >
                      <InputGroup className='input-group-merge input-group-alternative'>
                        <InputGroupAddon addonType='prepend'>
                          <InputGroupText>
                            <i className='ni ni-single-02' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder='Surname'
                          value={surname}
                          type='text'
                          onFocus={() => setfocusedEmail(true)}
                          onBlur={() => setfocusedEmail(false)}
                          onChange={(e) => setSurname(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <FormGroup
                      className={classnames('mb-3 mr-2', {
                        focused: focusedEmail,
                      })}
                    >
                      <InputGroup className='input-group-merge input-group-alternative'>
                        <InputGroupAddon
                          addonType='prepend'
                          className='bg-secondary'
                        >
                          <InputGroupText
                            style={{ backgroundColor: '#e9ecef' }}
                          >
                            <i className='ni ni-single-02' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          className='disabled-input'
                          placeholder='userName'
                          disabled
                          value={username}
                          type='text'
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames({
                        focused: focusedPassword,
                      })}
                    >
                      <InputGroup className='input-group-merge input-group-alternative'>
                        <InputGroupAddon addonType='prepend'>
                          <InputGroupText
                            style={{ backgroundColor: '#e9ecef' }}
                          >
                            <i className='ni ni-square-pin' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          className='disabled-input'
                          disabled
                          placeholder='location'
                          // disabled={true}
                          value={location}
                          type='text'
                        />
                      </InputGroup>
                    </FormGroup>
                  </div>
                  <div className='d-flex'>
                    <FormGroup
                      className={classnames('mb-3 w-100', {
                        focused: focusedEmail,
                      })}
                    >
                      <InputGroup className='input-group-merge input-group-alternative  d-flex justify-content-center'>
                        <InputGroupAddon addonType='prepend'>
                          <InputGroupText>
                            <i className='ni ni-email-83' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder='Email'
                          value={email}
                          type='email'
                          onFocus={() => setfocusedEmail(true)}
                          onBlur={() => setfocusedEmail(false)}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <FormGroup
                      className={classnames('mb-3 mr-2 ', {
                        focused: focusedEmail,
                      })}
                    >
                      <InputGroup className='input-group-merge input-group-alternative'>
                        <InputGroupAddon addonType='prepend'>
                          <InputGroupText>
                            <i className='ni ni-lock-circle-open' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder='Password'
                          type='password'
                          onFocus={() => setfocusedPassword(true)}
                          onBlur={() => setfocusedPassword(false)}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames('', {
                        focused: focusedPassword,
                      })}
                    >
                      <InputGroup className='input-group-merge input-group-alternative'>
                        <InputGroupAddon addonType='prepend'>
                          <InputGroupText>
                            <i className='ni ni-lock-circle-open' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder='Confirm Password'
                          type='password'
                          onFocus={() => setfocusedPassword(true)}
                          onBlur={() => setfocusedPassword(false)}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </div>
                  <div className='custom-control custom-control-alternative custom-checkbox'>
                    <input
                      className='custom-control-input'
                      id=' customCheckLogin'
                      type='checkbox'
                    />
                    {/* <label
											className='custom-control-label'
											htmlFor=' customCheckLogin'
										>
											<span className='text-muted'>Remember me</span>
										</label> */}
                  </div>
                  <div className='text-center'>
                    <Button
                      className='my-3'
                      color='info'
                      type='button'
                      onClick={onSubmit}
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ToastContainer />
      </Container>
    </>
  )
}

export default FirstLogin
